module.exports = __webpack_public_path__ + "img/pro_seven.11640f7c.jpg";